import $ from 'jquery';
import 'jquery-mask-plugin';

// Bloque les caractères spéciaux sur le numéro du contrat de la déclaration
$(function () {
    $('input#police_partenaire').mask('A', {
        translation: {
            A: { pattern: /^[a-zA-Z0-9_-]+$/, recursive: true }
        }
    });
});